import { render, staticRenderFns } from "./CEmptyState.vue?vue&type=template&id=028b6372&scoped=true"
import script from "./CEmptyState.vue?vue&type=script&lang=ts&setup=true"
export * from "./CEmptyState.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CEmptyState.vue?vue&type=style&index=0&id=028b6372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b6372",
  null
  
)

export default component.exports